"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.preloadImagesInModule = exports.getImages = exports.getItemFromProgram = exports.getItemPositionInProgram = exports.getItemFromPatientProgram = exports.getItemPositionInPatientProgram = exports.parseInternalLink = void 0;
var htmlUtils_1 = require("../youwell-common/htmlUtils");
var parseInternalLink = function (link) {
    var hashIndex = link.url.indexOf('#');
    var taskOrModuleId = link.url;
    var hash = '';
    if (hashIndex > -1) {
        taskOrModuleId = link.url.substring(0, hashIndex);
        hash = "#".concat(link.url.substring(hashIndex + 1));
    }
    return { taskOrModuleId: taskOrModuleId, hash: hash };
};
exports.parseInternalLink = parseInternalLink;
var getItemPositionInPatientProgram = function (patientProgram, taskOrModuleId) {
    var elementGroup = '';
    var elementIndex = -1;
    var taskIndex = -1;
    if (patientProgram) {
        var groups = Object.keys(patientProgram.groupedElements);
        for (var elementGroupIndex = 0; elementGroupIndex < groups.length; elementGroupIndex++) {
            var group = patientProgram.groupedElements[groups[elementGroupIndex]];
            for (elementIndex = 0; elementIndex < group.length; elementIndex++) {
                var el = group[elementIndex];
                elementGroup = el.elementGroup;
                if ((el.id === taskOrModuleId)
                    || (el.module && el.module.id === taskOrModuleId)
                    || (el.task && el.task.id === taskOrModuleId)) {
                    return { elementGroup: elementGroup, elementIndex: elementIndex, taskIndex: taskIndex };
                }
                if (el.module && el.module.tasks) {
                    for (taskIndex = 0; taskIndex < el.module.tasks.length; taskIndex++) {
                        var task = el.module.tasks[taskIndex];
                        if (task.id === taskOrModuleId) {
                            return { elementGroup: elementGroup, elementIndex: elementIndex, taskIndex: taskIndex };
                        }
                    }
                }
            }
        }
    }
    return { elementGroup: elementGroup, elementIndex: elementIndex, taskIndex: taskIndex };
};
exports.getItemPositionInPatientProgram = getItemPositionInPatientProgram;
var getItemFromPatientProgram = function (patientProgram, elementId) {
    if (patientProgram) {
        var groups = Object.keys(patientProgram.groupedElements);
        for (var elementGroupIndex = 0; elementGroupIndex < groups.length; elementGroupIndex++) {
            var group = patientProgram.groupedElements[groups[elementGroupIndex]];
            for (var elementIndex = 0; elementIndex < group.length; elementIndex++) {
                var el = group[elementIndex];
                // if (el.id === elementId) return el;
                // if (el.module && el.module.id === elementId) return el.module;
                if (el.task && el.task.id === elementId)
                    return el.task;
                if (el.module && el.module.tasks) {
                    for (var taskIndex = 0; taskIndex < el.module.tasks.length; taskIndex++) {
                        if (el.module.tasks[taskIndex].id === elementId) {
                            return el.module.tasks[taskIndex];
                        }
                    }
                }
            }
        }
    }
    return null;
};
exports.getItemFromPatientProgram = getItemFromPatientProgram;
var getItemPositionInProgram = function (program, elementId) {
    var moduleIndex = -1;
    var taskIndex = -1;
    if (program) {
        for (moduleIndex = 0; moduleIndex < program.modules.length; moduleIndex++) {
            var module_1 = program.modules[moduleIndex];
            if (module_1.id === elementId) {
                return { moduleIndex: moduleIndex, taskIndex: taskIndex };
            }
            if (module_1 && module_1.tasks) {
                for (taskIndex = 0; taskIndex < module_1.tasks.length; taskIndex++) {
                    var task = module_1.tasks[taskIndex];
                    if (task.id === elementId) {
                        return { moduleIndex: moduleIndex, taskIndex: taskIndex };
                    }
                }
            }
        }
    }
    return { moduleIndex: moduleIndex, taskIndex: taskIndex };
};
exports.getItemPositionInProgram = getItemPositionInProgram;
var getItemFromProgram = function (program, elementId) {
    var _a;
    if (program) {
        for (var moduleIndex = 0; moduleIndex < program.modules.length; moduleIndex++) {
            var module_2 = program.modules[moduleIndex];
            if ((module_2 === null || module_2 === void 0 ? void 0 : module_2.id) === elementId) {
                return module_2;
            }
            for (var taskIndex = 0; taskIndex < ((_a = module_2 === null || module_2 === void 0 ? void 0 : module_2.tasks) === null || _a === void 0 ? void 0 : _a.length); taskIndex++) {
                var task = module_2.tasks[taskIndex];
                if ((task === null || task === void 0 ? void 0 : task.id) === elementId) {
                    return task;
                }
            }
        }
    }
    return null;
};
exports.getItemFromProgram = getItemFromProgram;
var getImages = function (task) {
    var _a;
    return ((_a = task.contentElements) === null || _a === void 0 ? void 0 : _a.reduce(function (prev, curr) { return __spreadArray(__spreadArray([], prev, true), (0, htmlUtils_1.findImageUrls)(curr.htmlContent), true); }, [])) || [];
};
exports.getImages = getImages;
var preloadImagesInModule = function (module) {
    var _a;
    return (_a = module === null || module === void 0 ? void 0 : module.tasks) === null || _a === void 0 ? void 0 : _a.map(function (t) { return (0, exports.getImages)(t).map(function (id) {
        var img = new Image();
        img.src = id;
        return id;
    }); });
};
exports.preloadImagesInModule = preloadImagesInModule;
